import React from "react";
import { BaseURL } from "../../APIs/APIUrls";

export default function FloorPlan({ PropertyObject }) {
  // Supports:
  // 1) PropertyObject as direct array (like your sample)
  // 2) PropertyObject._lstPropertyFloor
  // 3) PropertyObject._lstPropertyImage
  const floorPlanData = React.useMemo(() => {
    const source = Array.isArray(PropertyObject)
      ? PropertyObject
      : Array.isArray(PropertyObject?._lstPropertyFloor)
        ? PropertyObject._lstPropertyFloor
        : Array.isArray(PropertyObject?._lstPropertyImage)
          ? PropertyObject._lstPropertyImage
          : [];

    return source
      .filter((x) => x?.IsActive !== false)
      .sort((a, b) => (a?.ImageIndex ?? 0) - (b?.ImageIndex ?? 0));
  }, [PropertyObject]);

  const getImageSrc = (url) => {
    if (!url) return "/images/banner/floor.png";
    if (/^https?:\/\//i.test(url)) return url;
    return `/${String(url).replace(/^\/+/, "")}`;
  };

  return (
    <>
      <h5 className="title fw-6">Floor plans</h5>

      {floorPlanData.length === 0 ? (
        <p>No floor plans available.</p>
      ) : (
        <ul className="box-floor" id="parent-floor">
          {floorPlanData.map((item, index) => {
            const collapseId = `floor-${item.ImageId ?? index}`;
            const isFirst = index === 0;

            return (
              <li className="floor-item" key={item.ImageId ?? index}>
                <div
                  className={`floor-header ${isFirst ? "" : "collapsed"}`}
                  data-bs-target={`#${collapseId}`}
                  data-bs-toggle="collapse"
                  aria-expanded={isFirst}
                  aria-controls={collapseId}
                >
                  <div className="inner-left">
                    <i className="icon icon-arr-r" />
                    <span className="text-btn">
                      {item.Value || `Floor ${index + 1}`}
                    </span>
                  </div>
                  <ul className="inner-right">
                    {
                      item.Bedrooms != null && item.Bedrooms > 0 && (
                        <li className="d-flex align-items-center gap-8">
                          <i className="icon icon-bed" />
                          {item.Bedrooms ?? null} Bedroom
                        </li>
                      )
                    }
                    {
                      item.Bathrooms != null && item.Bathrooms > 0 && (
                        <li className="d-flex align-items-center gap-8">
                          <i className="icon icon-bath" />
                          {item.Bathrooms ?? null} Bathroom
                        </li>
                      )
                    }
                  </ul>
                </div>

                <div
                  id={collapseId}
                  className={`collapse ${isFirst ? "show" : ""}`}
                  data-bs-parent="#parent-floor"
                >
                  <div className="faq-body">
                    <div className="box-img">
                      <img
                        alt={PropertyObject.PropertyTitle}
                        src={item.FloorPlanImage ? BaseURL + item.FloorPlanImage : "#"}
                        width={1158}
                        height={815}
                      />
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
}